import { inject, Injectable } from '@angular/core';
import { CountryApiClient } from '../api-clients';
import { first, shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CountryStore {
  private readonly _countryClient = inject(CountryApiClient);

  readonly countryOptions$ = this._countryClient.getListOptions().pipe(first(), shareReplay(1));
}
